var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard5Spades(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{clip-path:url(#SVGID_00000043439789945326166760000014822113961512175244_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v397.9c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.7 C309.4,6.6,302.8,0,294.7,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9,44.8c4,0,7.2-3.2,7.2-7.2s-3.2-7.2-7.2-7.2H28.8c-4,0-7.2,3.2-7.2,7.2s3.2,7.2,7.2,7.2H64.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6,73.7c0,4,3.2,7.2,7.2,7.2s7.2-3.2,7.2-7.2V37.6c0-4-3.2-7.2-7.2-7.2s-7.2,3.2-7.2,7.2V73.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7,118.6c16.4,0,29.7-13.3,29.7-29.7c0-16.4-13.3-29.7-29.7-29.7c-8.6,0-16.7,3.7-22.3,10c-2.6,3-2.4,7.5,0.6,10.2 c3,2.6,7.5,2.4,10.2-0.6c2.9-3.3,7-5.2,11.4-5.2c8.4,0,15.2,6.8,15.2,15.2S54,104,45.6,104c-4.4,0-8.5-1.9-11.4-5.2 c-2.6-3-7.2-3.3-10.2-0.6c-3,2.6-3.3,7.2-0.6,10.2C29,114.9,37,118.6,45.7,118.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.1,271.3L173.1,271.3c0,0,36.2,36.2,64.9-7.2c14.9-22.6,4.8-44.6-11.1-59.9l-68.6-67.5c-3.9-3.3-9.8-3.3-13.7,0 L75,204.2c-13.7,14.3-25.3,37.2-10.2,59.9c28.9,43.3,64.9,7.2,64.9,7.2c0,18.5-5.3,42.3-6.8,48.8c-0.2,0.9,0.5,1.7,1.4,1.7h54.1 c0.9,0,1.6-0.8,1.4-1.7C178.4,313.6,173.1,289.7,173.1,271.3"
  })), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M283,370.5c0,20.3-16.5,36.8-36.8,36.8s-36.8-16.5-36.8-36.8c0-20.3,16.5-36.8,36.8-36.8S283,350.1,283,370.5z M246.2,340 c-16.8,0-30.4,13.6-30.4,30.4s13.6,30.4,30.4,30.4s30.4-13.6,30.4-30.4S263,340,246.2,340z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.9,363.7c0,6.5-5.7,12.4-12.8,12.4c-7.2-0.3-12.8-5.9-12.8-12.4c0-6.5,5.7-12.2,12.8-12.4 C265.2,351.5,270.9,357.1,270.9,363.7z M265.8,363.7c0-4.2-3.5-7.6-7.8-7.6c-4.3,0-7.8,3.4-7.8,7.6s3.5,7.6,7.8,7.6 C262.3,371.2,265.8,367.9,265.8,363.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.2,386.7c0,3.5-3,6.3-6.9,6.5c-3.8,0-6.9-3-6.9-6.5c0-3.5,3.1-6.5,6.9-6.5C252.1,380.4,255.2,383.2,255.2,386.7z  M251,386.7c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.1-2.6,2.6s1.2,2.6,2.6,2.6C249.8,389.3,251,388.2,251,386.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.3,359.9c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C241.3,361.1,239.9,359.9,238.3,359.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M228.4,379.8c-1.6,0-3,1.3-3,2.8s1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8S230,379.8,228.4,379.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M264.2,383.5c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C267.1,384.8,265.8,383.5,264.2,383.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 246.2,
    cy: 370.5,
    r: 30.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101784846629529351200000008035525776689685161_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000101784846629529351200000008035525776689685161_)"
    },
    d: "M235.6,350.7 c-0.2,3.5-3.4,6.2-7.2,6c-3.8-0.2-6.7-3.4-6.4-6.9c0.2-3.5,3.4-6.3,7.2-6.1C232.9,344.2,235.8,347.3,235.6,350.7z M231.3,350.5 c0.1-1.4-1-2.6-2.5-2.7c-1.5-0.1-2.7,1-2.8,2.4s1,2.6,2.5,2.7C230,353,231.3,351.9,231.3,350.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard5Spades);
export default __webpack_public_path__ + "static/media/card_5-spades.57bad518a38242e853d6e089c0c72273.svg";
export { ForwardRef as ReactComponent };